import Button from '@hotmart/space-lib/dist/components/button'
import { Icon } from 'src/components'
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple'
import { faAndroid } from '@fortawesome/free-brands-svg-icons/faAndroid'
import i18n from 'src/i18n'
import useSendDataHubConsume from 'src/hook/useSendDatahubConsume/useSendDatahubConsume'
import { Actions, ComponentNames, Entities, EventNames, ScreenNames } from 'src/utils/datahub/enums'
import { HOTMART_APP_ANDROID_URL, HOTMART_APP_IOS_URL } from './appDownloadButtons.constants'
import { AppDownloadButtonsProps } from './appDownloadButtons.types'

const AppDownloadButtons = ({ onClick }: AppDownloadButtonsProps) => {
  const { sendDataHubConsume } = useSendDataHubConsume()

  const handleClick = (href: string, option: string) => {
    window.open(href, '_blank')

    sendDataHubConsume({
      action: Actions.VIEW,
      entity: Entities.COMMUNITY,
      event: {
        eventName: EventNames.CLICK_TO_APP_STORE,
        screenName: ScreenNames.COMMUNITY_POST_COMMENT,
        componentName: ComponentNames.INPUT_COMMENT,
        option
      }
    })

    onClick?.()
  }

  return (
    <>
      <h3 className="_text-4 _text-gray-700 _m-5 _text-center">{i18n.t('cta_audio.text_modal')}</h3>

      <div className="_d-flex _flex-column _flex-sm-row _justify-content-center _align-items-center _py-3">
        <Button
          variation="secondary"
          className="_d-flex _align-items-center _justify-content _ml-2 _mb-2 _w-full"
          onClick={() => handleClick(HOTMART_APP_IOS_URL, 'APPLE')}
        >
          <span>{i18n.t('cta_audio.download_app_ios')}</span>
          <Icon icon={faApple} className="_text-gray-700 _ml-auto" size="1x" />
        </Button>

        <Button
          variation="secondary"
          className="_d-flex _align-items-center _justify-content _ml-2 _mb-2 _w-full"
          onClick={() => handleClick(HOTMART_APP_ANDROID_URL, 'ANDROID')}
        >
          <span>{i18n.t('cta_audio.download_app_android')}</span>
          <Icon icon={faAndroid} className="_text-gray-700 _ml-auto" size="1x" />
        </Button>
      </div>
    </>
  )
}

export default AppDownloadButtons
